export * from './login.component';
export * from './login.trans';
